export const FileExtsForAnalyze = ['pdf', 'xml']

export interface DocumentSection {
  title: string
  pageStart: number
  pageEnd: number
}

export interface ExtractedFile {
  name: string
  ext: string
  mime: string
  fileKey: string
}
